import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';

const ConfirmationDialog = ({ data, onClose }) => {

    const [message, setMessage] = useState();

    useEffect(() => {
        if (data?.message) {
            setMessage(data.message);
        }
    }, [data]);

    return (
        <>
            <div style={{ color: '#fff', padding: '1rem 0.4rem', marginBottom: '1rem'  }}>
                {message}
            </div>
            <div>
                <Button style={{ marginRight: '10px' }} color="primary" variant="outlined" onClick={() => onClose('CANCEL')} disableElevation>Cancel</Button>
                <Button color="primary" variant="contained" onClick={() => onClose('CONFIRM')} disableElevation>Confirm</Button>
            </div >
        </>
    )
}

export default ConfirmationDialog;